export const useResponsiveStyles = (styles, resolution, isActive) => {
    if (styles[0]) {
        const currentStylesObj = styles[0]
        const activeStyles = currentStylesObj.activeStyles || {};
        if (resolution !== 'desktop') {
            const stylesByResolution = currentStylesObj[resolution] || {};
            return isActive ? {...stylesByResolution, ...activeStyles} : stylesByResolution
        }
        return isActive ? {...currentStylesObj, ...activeStyles} : currentStylesObj
    }

    return {};
}